import { action, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import WorkspacePostingStore from 'admin/WorkspacePostingStore'
import { CreateWorkspacePostingPayload } from 'admin/staffing/dtos/payloads'
import { AlertFactory, AlertState } from 'alerts/Alert'
import { GetCurrentUserWorkspaceMemberships } from 'iam/WorkspaceMembershipStore'
import { Id } from 'types/definitions'
import { WorkspacePostingDialogViewModel } from '../WorkspacePostingDialog/WorkspacePostingDialogViewModel'
import { extractMessageFromError } from 'utils/error-util'

export default class CreateWorkspacePostingViewModel extends WorkspacePostingDialogViewModel {
  constructor(
    private workspacePostingStore: WorkspacePostingStore,
    private newAlert: AlertFactory,
    private refreshStatusFilter: () => Promise<void>,
    getWorkspaceMemberships: GetCurrentUserWorkspaceMemberships
  ) {
    super(getWorkspaceMemberships)
    makeObservable(this, {
      submit: action.bound,
    })
  }

  /**
   * Create a workspace posting.
   */
  submit = task.resolved(async () => {
    if (!this.validate()) {
      return
    }

    const workspaceId = Id.assert(this.workspace?.id)
    const payload: CreateWorkspacePostingPayload = {
      location: this.location,
      primary_software: this.primarySoftware,
      backup_file_needed: this.backupRequired,
      supplemental_software: this.supplementalSoftware,
      specialties: this.specialties,
      capacity: this.prosRequired,
      max_allowed_workspaces: this.maxConcurrentWorkspaces,
      job_types: this.typeOfWork,
      description: this.description,
    }

    await this.workspacePostingStore
      .createWorkspacePosting(workspaceId, payload)
      .then(() => {
        this.refreshStatusFilter()

        this.newAlert()
          .withState(AlertState.Success)
          .saying('Success', 'Workspace posting created.')
          .autoDismiss()
          .show()

        this.close()
      })
      .catch((error) => {
        this.newAlert()
          .withState(AlertState.Error)
          .saying('Error', extractMessageFromError(error))
          .autoDismiss()
          .show()
      })
  })
}
